import { POST_VERIFY_SUCCESS } from 'modules/appointmentTask/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = false;

const openModal = () => true;

const closeModal = () => false;

export default createReducer(initialState, {
  [actionTypes.OPEN_LOCKER_VERIFY_CONFIRM_MODAL]: openModal,
  [actionTypes.CLOSE_LOCKER_VERIFY_CONFIRM_MODAL]: closeModal,
  [POST_VERIFY_SUCCESS]: closeModal,
});
